import React from 'react';
import IProdukt from '../../interfaces/IProdukt';
import { filterToLabel } from '../../utils/FilterHelper';
import classnames from 'classnames';
import * as styles from './CheckOptions.module.scss';

type Props = {
    filterType: string;
    product: IProdukt;
    value: any;
    onChange?: (data: any) => void;
}

export default (props: Props) => {
    const { product, filterType, value, onChange } = props;
    const filterName = filterType.charAt(0).toUpperCase() + filterType.slice(1);

    let filter;
    for (const f of product.filters) {
        if (f.typ === filterType) {
            filter = f;
        }
    }

    const defaultValues: Array<string> = value.split(", ");

    const werte: Array<{label: string; checked: boolean}> = filter.wert.split("|").map(item => ({label: item, checked: defaultValues.indexOf(item) !== -1 ? true : false}));





    // React.useEffect(() => {
    //     let found = false;
        
    //     for (const wert of werte) {
    //         if (wert === value) {
    //             found = true;
    //         }
    //     }
    //     if (!found) {
    //         defaultValue = werte[0]
    //         onChange(defaultValue );
    //     }
    // }, [product.filters]);
    


    const onCheckChange = (e) => {
        let newWerte = werte;

        newWerte.forEach((item, index) => {
            if (item.label === e.currentTarget.name) {
                newWerte[index].checked = e.currentTarget.checked;
            }
        })

        onChange(newWerte.filter(item => item.checked).map(item => item.label).join(", "));
    }

    return <div className="field  is-horizontal">
        <div className="field-label is-normal">
            <label className="label">{filterToLabel(filterName)}</label>
        </div>
        <div className="field-body">
            <div className="field">
                <div className="control">
                    {werte.map((option, optionKey) => {
                        return <label key={optionKey} className={classnames(["checkbox", styles.label])}>
                            <input style={{display: "none"}} type="checkbox" onChange={onCheckChange} name={option.label} checked={option.checked} />
                                <svg className={styles.checkboxSvg} width="20px" height="20px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" style={{fillRule: "evenodd", clipRule: "evenodd", strokeLinecap: "square", strokeMiterlimit:10}}>
                                    <rect x="0.375" y="0.375" width="18" height="18" style={{fill: "none", stroke: "#005792", strokeWidth: "0.75px"}}/>
                                    {(option.checked) && <path id="check" d="M3.187,9.906l5.576,5.577l7.296,-12.216" style={{fill: "none", stroke: "#005792", strokeWidth: "0.75px", strokeLinejoin: "round", strokeMiterlimit:1.5}}/> }
                                </svg>
                                <span>
                                    {option.label}
                                </span>
                                
                        </label>})}
                </div>
            </div>
        </div>
    </div>;
}